import * as React from "react";
import Badge, {badgeClasses} from "@mui/material/Badge";
import IconButton, {IconButtonProps} from "@mui/material/IconButton";
import {gray} from "@/theme/themePrimitives";
import {alpha, Theme} from "@mui/material/styles";
import {svgIconClasses} from "@mui/material/SvgIcon";

export interface MenuButtonProps extends IconButtonProps {
    showBadge?: boolean;
}

export default function MenuButton({
                                       showBadge = false,
                                       ...props
                                   }: MenuButtonProps) {
    return (
        <Badge
            color="error"
            variant="dot"
            invisible={!showBadge}
            sx={{[`& .${badgeClasses.badge}`]: {right: 2, top: 2}}}
        >
            <IconButton
                sx={(theme: Theme) => ({
                    boxShadow: "none",
                    borderRadius: (theme.vars || theme).shape.borderRadius,
                    textTransform: "none",
                    fontWeight: theme.typography.fontWeightMedium,
                    letterSpacing: 0,
                    color: (theme.vars || theme).palette.text.primary,
                    border: "1px solid",
                    borderColor: gray[200],
                    backgroundColor: alpha(gray[50], 0.3),
                    "&:hover": {
                        backgroundColor: gray[100],
                        borderColor: gray[300],
                    },
                    "&:active": {
                        backgroundColor: gray[200],
                    },
                    ...theme.applyStyles("dark", {
                        backgroundColor: gray[800],
                        borderColor: gray[700],
                        "&:hover": {
                            backgroundColor: gray[900],
                            borderColor: gray[600],
                        },
                        "&:active": {
                            backgroundColor: gray[900],
                        },
                    }),
                    width: "2.5rem",
                    // height: "2.25rem",
                    padding: "0.25rem",
                    [`& .${svgIconClasses.root}`]: {fontSize: "1rem"},
                })}
                size="medium"
                {...props}
            />
        </Badge>
    );
}
